export default __webpack_public_path__ + "static/media/offer-chocolate.43a2b728.png";